import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { AlertCircle, Droplets, Receipt, ShieldAlert } from 'lucide-react';
import { motion } from 'framer-motion';
const painPoints = [{
  icon: <ShieldAlert className="w-8 h-8 text-amber" data-id="element-149" />,
  text: 'Productos comerciales llenos de químicos que no entiendes'
}, {
  icon: <Receipt className="w-8 h-8 text-amber" data-id="element-150" />,
  text: 'Cremas costosas que prometen mucho y cumplen poco'
}, {
  icon: <AlertCircle className="w-8 h-8 text-amber" data-id="element-151" />,
  text: 'Irritaciones y reacciones alérgicas por ingredientes sintéticos'
}, {
  icon: <Droplets className="w-8 h-8 text-amber" data-id="element-152" />,
  text: 'Falta de control sobre lo que realmente contienen tus productos'
}];
export function ProblemSection() {
  return <SectionWrapper id="problema" className="px-4 md:px-12 max-w-5xl mx-auto" data-id="element-153">
      <div className="bg-amber/5 rounded-3xl p-8 md:p-16 border border-amber/20" data-id="element-154">
        <h2 className="text-3xl md:text-5xl font-playfair text-forest text-center mb-12" data-id="element-155">
          ¿Te preocupa lo que aplicas en tu piel?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-156">
          {painPoints.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex items-start bg-white/60 p-6 rounded-2xl shadow-sm border border-amber/10" data-id="element-157">
              <div className="shrink-0 mr-4 mt-1" data-id="element-158">{point.icon}</div>
              <p className="text-lg text-brown/90 font-medium leading-relaxed" data-id="element-159">
                {point.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </SectionWrapper>;
}